const NAMES = {
    ajaxModuleUpdate: 'ajax-module-update-event',
    allCatsLinkClicked: 'all-cats-link-clicked-event',
    changeToTab: 'change-to-tab-event',
    closeProfileEditDrawer: 'close-profile-edit-drawer-event',
    openAddToCart: 'open-add-to-cart-event',
    openOverflowDrawer: 'open-overflow-drawer-event',
    openMobileCatLayer: 'open-mobile-cat-layer-event',
    openShareDrawer: 'open-share-drawer-event',
    openQuickview: 'open-quickview-event',
    presenceEdit: 'presenceEdit',
    quickviewCarouselIndex: 'quickview-carousel-index-event',
    stickyHeaders: 'sticky-headers-event',
    stickyLeftNav: 'sticky-left-nav-event',
    tabHasChanged: 'str-tab-change-event',
    toggleLeftNav: 'toggle-left-nav-event',
    toggleLeftNavDone: 'toggle-left-nav-done-event',
    watchAttempt: 'watch-attempt-event',
    watchSuccess: 'watch-success-event'
};

export default {
    ajaxModuleUpdate: newEvent(NAMES.ajaxModuleUpdate),
    allCatsLinkClicked: newEvent(NAMES.allCatsLinkClicked),
    changeToTab: newEvent(NAMES.changeToTab),
    openAddToCart: newEvent(NAMES.openAddToCart),
    openOverflowDrawer: newEvent(NAMES.openOverflowDrawer),
    openMobileCatLayer: newEvent(NAMES.openMobileCatLayer),
    openShareDrawer: newEvent(NAMES.openShareDrawer),
    openQuickview: newEvent(NAMES.openQuickview),
    presenceEdit: newEvent(NAMES.presenceEdit),
    quickviewCarouselIndex: newEvent(NAMES.quickviewCarouselIndex),
    stickyHeaders: newEvent(NAMES.stickyHeaders),
    stickyLeftNav: newEvent(NAMES.stickyLeftNav),
    tabHasChanged: newEvent(NAMES.tabHasChanged),
    toggleLeftNav: newEvent(NAMES.toggleLeftNav),
    toggleLeftNavDone: newEvent(NAMES.toggleLeftNavDone),
    watchAttempt: newEvent(NAMES.watchAttempt),
    watchSuccess: newEvent(NAMES.watchSuccess)
};

function newEvent(eventName) {
    return {
        listen: callback => {
            document.addEventListener(eventName, evt => {
                callback(evt.detail);
            });
        },
        dispatch: data => {
            const tabEvt = new CustomEvent(eventName, { detail: data });
            document.dispatchEvent(tabEvt);
        }
    };
}
